<script>
import { getSitemapEntry } from '../utils'

// Shared renderer for boligvelger actions that carry a single residential id
// (analytics:favorite:residential, analytics:floorplan:residential). The i18n string for
// `value.event` provides the sentence with a {residential} slot.
export default {
  props: {
    value: Object,
    scope: Object,
  },
  data() {
    return {
      entry: null,
    }
  },
  created() {
    getSitemapEntry(this.scope, this.value.data.residential).then(entry => {
      this.entry = entry
    })
  },
}
</script>

<template>
  <i18n :path="value.event" tag="div">
    <template #residential>
      <a v-if="entry" :href="entry.url" target="_blank">{{ entry.pagetitle }}</a>
      <span v-else>{{ value.data.residential }}</span>
    </template>
  </i18n>
</template>
